import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import defaultAvatar from "../../../../assets/images/avatar.png";
import { useDispatch } from "react-redux";
import { updateHrmsUser } from "../../../../Redux/slice/features/authSlice";

const EmployeeViewEditModal = ({
    show,
    onClose,
    employee,
    editMode,
    setEditMode,
    onSuccess,
}) => {
    const [formData, setFormData] = useState({}); const [imageFile, setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const dispatch = useDispatch();
    const appendIfValid = (fd, key, value) => {
        if (
            value !== undefined &&
            value !== null &&
            value !== "" &&
            value !== "null"
        ) {
            fd.append(key, value);
        }
    };

    useEffect(() => {
        setFormData(employee || {});
    }, [employee]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageFile(file);
        setPreview(URL.createObjectURL(file));
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        const formDataPayload = new FormData();
        const normalizeDate = (date) =>
            date ? new Date(date).toISOString() : null;

        appendIfValid(formDataPayload, "Name", formData.vchFullName);
        appendIfValid(formDataPayload, "Email", formData.vchEmail);
        appendIfValid(formDataPayload, "Mobile", formData.vchMobTel);
        appendIfValid(formDataPayload, "Address", formData.vchPreAddress);
        appendIfValid(formDataPayload, "Department", formData.vchDepartment);
        appendIfValid(formDataPayload, "Designation", formData.vchDesignation);
        appendIfValid(formDataPayload, "CompanyName", formData.vchCompanyName);
        appendIfValid(formDataPayload, "Gender", formData.vchGender);

        if (formData.dtmDob) {
            formDataPayload.append("Dob", normalizeDate(formData.dtmDob));
        }
        if (formData.dtmDoj) {
            formDataPayload.append("DateOfJoining", normalizeDate(formData.dtmDoj));
        }

        if (imageFile) {
            formDataPayload.append("UserImage", imageFile);
        }

        try {
            const res = await axios.put(
                `${REACT_APP_API_URL}api/hrms/update-employee/${employee.Id}`,
                formDataPayload,
                {
                    withCredentials: true,
                }
            );

            window.alert(res.data.message || "Employee updated successfully");

            const updatedHrmsUser = {
                name: formData.vchFullName,
                employee_id: employee.vchEmpCode,
                department: formData.vchDepartment,
                designation: formData.vchDesignation,
                vchUserImage: res.data.userImage || employee.vchUserImage
            };

            dispatch(updateHrmsUser(updatedHrmsUser));
            if (onSuccess) onSuccess(updatedHrmsUser);

            setPreview(null);
            setImageFile(null);
            onClose();

        } catch (err) {
            console.error("Update failed:", err);
            window.alert("Failed to update employee. Please try again.");
        }
    };

    if (!employee) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    {/* Header */}
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editMode ? "Update Employee" : "Employee Details"}
                        </h5>

                        {!editMode && (
                            <button
                                className="btn btn-sm btn-outline-warning m-3 me-2"
                                onClick={() => setEditMode(true)}
                            >
                                Edit
                            </button>
                        )}

                        <button className="btn-close" onClick={onClose} />
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-md-4 text-center">
                                <img
                                    src={
                                        preview ||
                                        (employee?.vchUserImage
                                            ? `${REACT_APP_API_URL}${employee.vchUserImage.replace(/\\/g, "/")}?t=${Date.now()}`
                                            : defaultAvatar)
                                    }
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultAvatar;
                                    }}
                                    className="rounded-circle mb-3"
                                    width="120"
                                    height="120"
                                    alt="Employee"
                                />

                                {editMode && (
                                    <input
                                        type="file"
                                        className="form-control mt-2"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                    />
                                )}
                            </div>

                            <div className="col-md-8">
                                <p>
                                    <b>Employee ID:</b> {employee.vchEmpCode}
                                </p>
                                <p>
                                    <b>Full Name:</b> {employee.vchFullName}
                                </p>

                                {!editMode ? (
                                    <>
                                        <p><b>Email:</b> {employee.vchEmail}</p>
                                        <p><b>Phone:</b> {employee.vchMobTel}</p>
                                        <p><b>Department/Unit:</b> {employee.vchDepartment}</p>
                                        <p><b>Designation:</b> {employee.vchDesignation}</p>
                                        <p><b>Address:</b> {employee.vchPreAddress}</p>
                                        <p>
                                            <b>Date of Joining:</b>{" "}
                                            {employee.dtmDoj ? employee.dtmDoj.split("T")[0] : "-"}
                                        </p>
                                        <p>
                                            <b>Date of Birth:</b>{" "}
                                            {employee.dtmDob ? employee.dtmDob.split("T")[0] : "-"}
                                        </p>
                                        <p><b>Company:</b> {employee.vchCompanyName}</p>
                                        <p><b>Gender:</b> {employee.vchGender}</p>
                                    </>
                                ) : (
                                    <form onSubmit={handleUpdate}>
                                        <div className="row g-2">
                                            <div className="col-md-6">
                                                <label className="form-label">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="vchEmail"
                                                    value={formData.vchEmail || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Phone</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="vchMobTel"
                                                    value={formData.vchMobTel || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Department/Unit</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="vchDepartment"
                                                    value={formData.vchDepartment || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Designation</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="vchDesignation"
                                                    value={formData.vchDesignation || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-12">
                                                <label className="form-label">Address</label>
                                                <textarea
                                                    className="form-control"
                                                    name="vchPreAddress"
                                                    value={formData.vchPreAddress || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Company</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="vchCompanyName"
                                                    value={formData.vchCompanyName || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Gender</label>
                                                <select
                                                    className="form-control"
                                                    name="vchGender"
                                                    value={formData.vchGender || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Date of Birth</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="dtmDob"
                                                    value={formData.dtmDob?.split("T")[0] || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Date of Joining</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="dtmDoj"
                                                    value={formData.dtmDoj?.split("T")[0] || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="text-end mt-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={() => setEditMode(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-success">
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeViewEditModal;
